export const EVENTS = {
	CLICK: 'click',
	BOT_DETECTION: 'botDetection'
};

export const PAGE_ID = {
	APP_LAUNCH: 'appLaunchPage',
	DASHBOARD: 'dashboard',
	DASHBOARD_METADATA: 'dashboardMetadata',
	TEMPLATES: 'templates',
	PREVIEW: 'preview',
	REPORT_SETTINGS: 'reportSettings',
	QUICK_REPORT: 'quickReport'
};

export const PAGE_NAME = {
	APP_LAUNCH: 'App Launch',
	DASHBOARD: 'Dashboard',
	DASHBOARD_METADATA: 'Dashboard Meta-data',
	TEMPLATES: 'Template selection page',
	PREVIEW: 'Preview page',
	REPORT_SETTINGS: 'Report Settings',
	QUICK_REPORT: 'Quick report'
};

export const ACTION_ON = {
	DOWNLOAD_BUTTON: 'Download report',
	DELETE_REPORT_BUTTON: 'Delete report',
	CREATE_REPORT_BUTTON: 'Create report',
	SELECT_TEMPLATE_BTN: 'Select template',
	EDIT_REPORT_BUTTON: 'Edit report',
	DUPLICATE_REPORT: 'Duplicate report',
	BUILD_REPORT_BUTTON: 'Build report',
	SHARE_REPORT_BUTTON: 'Share report',
	REMOVE_ACCESS_BUTTON: 'Remove access of report',
	LEAVE_REPORT: 'Leave report',
	DUPLICATE_SHARED_REPORT: 'Create a copy of shared report',
	DOWNLOAD_SHARED_REPORT: 'Download shared report',
	BUILD_QUICK_REPORT: 'Build quick report',
	CUSTOMIZE_QUICK_REPORT: 'Customize quick report',
	ITEM_SHARE_ACCEPTANCE: 'Item share accepted by the user',
	SAVE_REPORT_FROM_DASHBOARD: 'Report added to save',
	SAVE_REPORT_FROM_PREVIEW: 'Report saved from preview page',
	EDIT_DRAFT: 'Edit draft',
	CRETE_REPORT_FROM_DRAFT: 'Report created from draft',
	RENAME_DRAFT: 'Rename draft',
	DELETE_DRAFT: 'Delete draft',
	BOT_DETECTION: 'botDetection',
	/* Custom Dataset */
	CUSTOM_DATASET_TOUR_SHOW_ME_HOW: 'Custom Dataset Start Tour',
	CUSTOM_DATASET_TOUR_GOT_IT: 'Custom Dataset Finish Tour',
	CUSTOM_DATASET_LEARN_MORE: 'Custom Dataset Learn More',
	CUSTOM_DATASET_GIVE_FEEDBACK: 'Custom Dataset Give Feedback',
	CUSTOM_DATASET_SELECTION: 'Custom Dataset Select Dataset',
	CUSTOM_DATASET_UPDATE: 'Custom Dataset Edit Dataset',
	CUSTOM_DATASET_RENAME: 'Custom Dataset Rename Dataset',
	CUSTOM_DATASET_DELETE: 'Custom Dataset Delete Dataset',
	CUSTOM_DATASET_SAVED: 'Custom Dataset Save Dataset',
	CUSTOM_DATASET_UNSAVED: 'Custom Dataset UnSaved Dataset',
	CUSTOM_DATASET_TABLE_DETAILS: 'Custom Dataset Table Details',
	CUSTOM_DATASET_SAVE_REPORT: 'Custom Dataset Save Report',
	CUSTOM_DATASET_SHARE_REPORT: 'Custom Dataset Share Report',
	CUSTOM_DATASET_CREATE_REPORT: 'Custom Dataset Create Report',
	CUSTOM_DATASET_UPDATE_REPORT: 'Custom Dataset Update Report',
	CUSTOM_DATASET_TRIGGER_CREATE_CLICK: 'Custom Dataset Trigger Create Click'
};
